import React, { Component } from 'react';
import {
  GeckoModal,
  GECKO_CONSTS,
  GeckoModalService,
  GeckoToastService,
} from '../../../ui';
import { connect } from 'react-redux';
import GeckoLocation from '../../../services/gecko-location';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import Loader from 'components/Loader';

class RadiusLoginModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      host: '',
      loading: false,
    };
  }

  fields = [
    {
      key: 'username',
      label: 'Username',
      required: true,
      width: '100%',
      type: GECKO_CONSTS.FIELD_TYPE_NAME,
    },
    {
      key: 'password',
      label: 'Password',
      required: true,
      width: '100%',
      type: GECKO_CONSTS.FIELD_TYPE_PASSWORD,
    },
    {
      key: 'host',
      label: 'Radius Host URL',
      required: true,
      options: [
        {
          value: 'https://apacapi.radiusbycampusmgmt.com',
          label: 'APAC',
        },
        {
          value: 'https://emeaapi.radiusbycampusmgmt.com',
          label: 'EMEA',
        },
        {
          value: 'https://api.radiusbycampusmgmt.com',
          label: 'US',
        },
        {
          value: 'https://useastapi.radiusbycampusmgmt.com/',
          label: 'US - East',
        },
      ],
      width: '100%',
      type: GECKO_CONSTS.FIELD_TYPE_SELECT,
    },
  ];

  footerButtons = [
    {
      name: 'Done',
      type: 'primary',
      icon: 'far fa-check',
      handler: () => {
        this.handleSubmit.bind(this)();
      },
    },
  ];

  onUserInput(e, val) {
    this.setState({ [e]: val });
  }

  handleSubmit() {
    const newConnectIntegration = {
      type: 'radius',
      configuration: {
        username: this.state.username,
        password: this.state.password,
        host: this.state.host,
      },
      account_id: this.props.current_user.account_id,
    };
    this.setState({ loading: true });
    return GeckoRequest.post('/integration/', newConnectIntegration)
      .then((integration) => {
        if (integration.id) {
          GeckoLocation.goTo(`/settings/integration/radius`);
          new GeckoToastService().success('Radius integration created');
          return new GeckoModalService().close();
        } else {
          new GeckoToastService().error(integration.error);
        }
      })
      .catch(renderError)
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    return (
      <Loader isLoading={this.state.loading}>
        <GeckoModal
          name="Please enter your Radius Login details:"
          values={this.state}
          fields={this.fields}
          btns={this.footerButtons}
          handler={this.onUserInput.bind(this)}
        />
      </Loader>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultHeaders: state.appState.defaultHeaders,
    current_user: state.appState.loggedInUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(RadiusLoginModal);
